import { OutputType } from '../enums/output-type.enum';
import { SelectionType } from '../enums/selection-type.enum';

export interface ISelectionConfig {
  selectionType: SelectionType;
  outputType: OutputType;
}
